import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2, Calculator } from "lucide-react";
import { useHomeImages } from "@/hooks/useHomeImages";
const Hero = () => {
  const {
    images,
    loading
  } = useHomeImages();

  // Image de fallback si aucune image n'est disponible
  const fallbackBackgroundImage = "/lovable-uploads/328f4f86-9058-4b88-b6b8-5bcc727eb914.png";

  // Utiliser la première image du bucket comme arrière-plan, sinon l'image de fallback
  const backgroundImage = images.length > 0 ? images[0].url : fallbackBackgroundImage;
  return <div className="relative">
      <div className="bg-cover bg-center min-h-[600px] flex items-center relative overflow-hidden" style={{
      backgroundImage: `linear-gradient(135deg, rgba(140, 198, 63, 0.9), rgba(98, 146, 158, 0.8)), url('${backgroundImage}')`
    }}>
        {/* Decorative elements */}
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full -translate-y-48 translate-x-48"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-white/5 rounded-full translate-y-32 -translate-x-32"></div>
        <div className="absolute top-1/3 right-1/4 w-32 h-32 bg-fabre-lightgreen/20 rounded-full"></div>
        
        <div className="container mx-auto px-4 z-10 relative">
          <div className="max-w-3xl">
            
            {/* Left Content */}
            <div className="text-white">
              
              
              <div className="flex items-center gap-4 mb-6">
                <img src="/lovable-uploads/2e9c2ce6-c821-428b-baa4-bd3137a03d49.png" alt="Groupe Fabre" className="w-16 h-16 drop-shadow-lg" />
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold drop-shadow-lg leading-tight">
                  Ensemble, valorisons
                  <span className="text-fabre-lightgreen block"> vos déchets</span>
                </h1>
              </div>
              
              <p className="text-xl md:text-2xl mb-8 drop-shadow-md leading-relaxed text-gray-100">
                Depuis plus de <strong className="text-fabre-lightgreen">35 ans</strong>, nous développons une approche 
                responsable et innovante pour transformer vos déchets en ressources précieuses.
              </p>
              
              {/* Key Benefits */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
                <div className="flex items-center">
                  <CheckCircle2 className="h-6 w-6 mr-3 text-fabre-lightgreen flex-shrink-0" />
                  <span className="font-medium">Solutions sur-mesure</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle2 className="h-6 w-6 mr-3 text-fabre-lightgreen flex-shrink-0" />
                  <span className="font-medium">8 départements couverts</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle2 className="h-6 w-6 mr-3 text-fabre-lightgreen flex-shrink-0" />
                  <span className="font-medium">Expertise reconnue</span>
                </div>
                <div className="flex items-center">
                  <CheckCircle2 className="h-6 w-6 mr-3 text-fabre-lightgreen flex-shrink-0" />
                  <span className="font-medium">Économie circulaire</span>
                </div>
              </div>
              
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-10">
                <Button asChild className="w-full bg-fabre-lightgreen text-fabre-darkgreen hover:bg-white hover:text-fabre-green text-base md:text-lg px-6 md:px-8 py-5 h-auto font-semibold shadow-xl">
                  <Link to="/nos-services/location-bennes" aria-label="Location de bennes - Demander un devis">
                    Location de bennes
                    <ArrowRight className="ml-2" />
                  </Link>
                </Button>
                <Button asChild variant="outline" className="w-full bg-white/10 backdrop-blur-sm border-2 border-white text-white hover:bg-white hover:text-fabre-green text-base md:text-lg px-6 md:px-8 py-5 h-auto font-semibold shadow-lg">
                  <Link to="/nos-services/achat-metaux" aria-label="Achat de métaux ferreux et non ferreux">
                    Achat de métaux
                    <ArrowRight className="ml-2" />
                  </Link>
                </Button>
                <Button asChild variant="outline" className="w-full bg-white/0 border-2 border-white/40 text-white hover:bg-white hover:text-fabre-green text-base md:text-lg px-6 md:px-8 py-5 h-auto font-semibold shadow-lg">
                  <Link to="/nos-services" aria-label="Tous nos services">
                    Tous nos services
                    <ArrowRight className="ml-2" />
                  </Link>
                </Button>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      
      {/* Vague décorative améliorée */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden">
        <svg className="relative block w-full h-[60px]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 100" preserveAspectRatio="none">
          <path fill="#ffffff" fillOpacity="1" d="M0,32L80,42.7C160,53,320,75,480,74.7C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,100L1360,100C1280,100,1120,100,960,100C800,100,640,100,480,100C320,100,160,100,80,100L0,100Z"></path>
        </svg>
      </div>
    </div>;
};
export default Hero;